<div class="accordion-container" [attr.style]="getStyle()">
 

  <div class="accordion-item" *ngFor="let panel of panels">

    <!--<pre>{{panel | json}} </pre>-->
    <div id="{{panel.id}}-header" class="accordion-header {{size}}" (click)="togglePanel(panel)">
      <span>{{panel.title}}</span>
      <div class="accordion-header-images" [ngClass]="panel.expanded?'':'collapsed'">
        <span class="fa fa-fw fa-chevron-down"></span>
        <span class="fa fa-fw fa-chevron-left"></span>
      </div>
    </div>
    <div [ngClass]="{'scroll':accordionScroll,'accordion-body':true}" id="{{panel.id}}" [ngStyle]="{'width':'400px!important'}" [ngbCollapse]="!panel.expanded">
      <ng-template [ngTemplateOutlet]="panel.contentPnl?.templateRef || null"></ng-template>
    </div>
  </div>
</div>
